import { IconButton, type IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AppSignUpIconButton = styled(IconButton)<IconButtonProps>(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  ":hover": {
    backgroundColor: "transparent",
  },
}));
